<ds-access-control-form-container
  titleMessage="item-access-control-title"
  *ngIf="itemRD$ | async as itemRD"
  [itemRD]="itemRD"
  [showLimitToSpecificBitstreams]="true">
</ds-access-control-form-container>
